export enum UploadStatus {
  Completed = "Completed", InProgress = "InProgress", Failed = "Failed"
}
